export interface RenderTriggerStyles {
  style?: React.CSSProperties;
}

export const styles: RenderTriggerStyles = {
  style: {
    fontFamily: 'Avenir',
  },
};
